module.exports = {
      id: "vikatanplay-usage",
      viewBox: "0 0 22.5 23.3",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#vikatanplay",
      toString: function () {
        return this.url;
      }
    }